import { Helmet } from "react-helmet-async";
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Header } from "@/components/Header";
import { KnowledgeConnections } from "@/components/knowledge/KnowledgeConnections";
import { Footer } from "@/components/Footer";
import { BreadcrumbNav } from "@/components/BreadcrumbNav";
import { JsonLd } from "@/components/JsonLd";
import { generateCanonicalUrl } from "@/utils/seoHelpers";

const SEOSugarLandPage = () => {
  const [language, setLanguage] = useState<'es' | 'en'>('es');
  const toggleLanguage = () => setLanguage(language === 'es' ? 'en' : 'es');
  const canonicalUrl = generateCanonicalUrl('/seo-sugar-land');

  const serviceSchema = {
    "@context": "https://schema.org",
    "@type": "Service",
    "serviceType": "SEO en Sugar Land TX",
    "provider": { "@id": "https://luisroc.com/#organization" },
    "areaServed": { "@type": "City", "name": "Sugar Land" }
  };

  return (
    <>
      <Helmet>
        <html lang={language} />
        <title>SEO Sugar Land TX | Posicionamiento Local – Luis ROC</title>
        <meta name="description" content="Agencia SEO en Sugar Land, Texas. Posicionamiento en Google Maps y búsquedas locales. Reunión inicial gratuita." />
        <meta name="keywords" content="seo sugar land tx, agencia seo sugar land" />
        <link rel="canonical" href={canonicalUrl} />
      </Helmet>

      <JsonLd data={serviceSchema} />

      <div className="min-h-screen bg-background">
        <Header language={language} onLanguageChange={toggleLanguage} />
        
        <main className="container mx-auto px-4 py-8">
          <BreadcrumbNav 
            items={[
              { name: "Servicios", url: "/servicios" },
              { name: "Localidades", url: "/servicios-locales-houston" },
              { name: "SEO Sugar Land", url: "/seo-sugar-land" }
            ]}
            language="es"
          />

          <section className="py-16 text-center">
            <h1 className="text-4xl md:text-5xl font-bold mb-6">
              SEO en Sugar Land TX — Mejora tu visibilidad local en Google
            </h1>
            
            <p className="text-lg text-muted-foreground max-w-3xl mx-auto mb-8">
              Sugar Land es una comunidad próspera con más de 111,000 habitantes. Optimiza tu presencia local 
              en Google para capturar clientes en ZIP 77478, 77479, 77487.
            </p>

            <Button size="lg" onClick={() => window.location.href = '/diagnostico-seo-gratis'}>
              Reunión inicial gratuita de 30 minutos
            </Button>
          </section>
        </main>

        <KnowledgeConnections path="/seo-sugar-land" language={language} />

        <Footer language={language} />
      </div>
    </>
  );
};

export default SEOSugarLandPage;
